import {
  ClearButtonBehaviour,
  Select,
  SelectProps,
} from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  SelectFormControlEntry,
  SelectFormControlEntryType,
  SelectFormControlViewModel,
} from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';

interface Props
  extends
    Omit<TFormControlConnectorProps, 'onChange' | 'onChanged' | 'onSubmit'>,
    Pick<
      SelectProps<string | number | null>,
      'onChange' | 'onChanged' | 'onSubmit' | 'onValidate'
    > {
  control: SelectFormControlViewModel;
}

const messages = defineMessages({
  all: {
    id: 'core.form.select.all',
    defaultMessage: 'All',
  },
});

const FormSelectInputControl: React.FC<Props> = ({
  areHintsShown,
  control,
  onChange,
  onChanged,
  onSubmit,
  onValidate,
}) => {
  const { formatMessage } = useIntl();
  const optionShadow: SelectFormControlEntry[] = [...control.options];
  if (control.addAll) {
    optionShadow.unshift({
      type: SelectFormControlEntryType.OPTION,
      value: null,
      label: formatMessage(messages.all),
    });
  }

  return (
    <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
      <Select<string | number | null>
        invalid={control.invalid}
        name={control.name}
        required={control.required}
        value={control.value}
        onChange={onChange}
        onChanged={onChanged}
        disabled={control.disabled}
        readOnly={control.readonly}
        disableButtonOnReadOnly={!control.enableButtonOnReadOnly}
        options={optionShadow}
        onSubmit={onSubmit}
        withClearButton={ClearButtonBehaviour.NONE}
        onValidate={onValidate}
      />
    </FormLabeledInputControl>
  );
};

export default FormSelectInputControl;
